export const SET_DETAIL_TABLE = 'boilderplate/PreviewAndSubmit/SET_DETAIL_TABLE';

export const LOADER_STATUS = 'boilderplate/PreviewAndSubmit/LOADER_STATUS';

export const SET_B2B_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_B2B_SUMMARY'

export const SET_B2BA_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_B2BA_SUMMARY'

export const SET_CDNUR_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_CDNUR_SUMMARY'

export const SET_EXPA_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_EXPA_SUMMARY'

export const SET_DOC_ISSUE_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_DOC_ISSUE_SUMMARY'

export const SET_TXPD_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_TXPD_SUMMARY'

export const SET_TXPDA_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_TXPDA_SUMMARY'

export const SET_HSN_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_HSN_SUMMARY'

export const SET_EXP_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_EXP_SUMMARY'

export const SET_CDNURA_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_CDNURA_SUMMARY'

export const SET_NIL_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_NIL_SUMMARY'

export const SET_CDNRA_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_CDNRA_SUMMARY'

export const SET_CDNR_SUMMARY =  'boilderplate/PreviewAndSubmit/SET_CDNR_SUMMARY'

export const SET_B2CL_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_B2CL_SUMMARY'

export const SET_B2CLA_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_B2CLA_SUMMARY'

export const SET_B2CSA_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_B2CSA_SUMMARY'

export const SET_B2CS_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_B2CS_SUMMARY'

export const SET_AT_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_AT_SUMMARY'

export const SET_ATA_SUMMARY = 'boilderplate/PreviewAndSubmit/SET_ATA_SUMMARY'

export const SET_DOWNLOAD_BUTTON = 'boilderplate/PreviewAndSubmit/SET_DOWNLOAD_BUTTON'

export const SET_OTP_BOX = 'boilderplate/PreviewAndSubmit/SET_OTP_BOX';

export const OTP_INVALID = 'boilderplate/UploadedData/OTP_INVALID';

export const SUMMARY_TO_FILE = 'boilderplate/PreviewAndSubmit/SUMMARY_TO_FILE';